import React, { useState } from "react";
import { Button, StringField } from "@culturehq/components";
import { t, Trans } from "app/utils";

const LinkedinComment = ({ comment, onPostSocialComment }) => {
  const [newComment, setNewComment] = useState("");

  const handleCommentChange = value => {
    setNewComment(value);
  };

  const onPostComment = async () => {
    onPostSocialComment(newComment, comment.$URN);
    setNewComment("");
  };


  return (
    <div className="Linkedin-Comments">
      <StringField
        onChange={handleCommentChange}
        placeholder={t("Add a comment...")}
        value={newComment}
      />
      <Button onClick={onPostComment}>
        <Trans>Post</Trans>
      </Button>
    </div>
  );
};

export default LinkedinComment;
